import { render, staticRenderFns } from "./Partie5.vue?vue&type=template&id=bd4f84e2&"
import script from "./Partie5.vue?vue&type=script&lang=js&"
export * from "./Partie5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports